export const svgOpenFunctions = {
    data() {
        return {
            dialog: false,
            pb: false,
            columnNum: null,
            kcpGroupId: null,
            row: null,
            regionId: null,
            regionName: null,
            uslName: null,
            foName: null,
            sprKcpGroupId: null,
            sprKcpGroupName: null,
            key: 1
        }
    },
    methods: {
        cellClick(row, columnNum, dash) {
            if (!row.regionId && row.districtId)
                return;
            // eslint-disable-next-line no-unreachable
            // console.log(row, dash)
            /*kcpGroupId, regionId, regionName, sprKcpGroupId, sprKcpGroupName,*/
            this.key = Math.random();
            this.columnNum = null;
            this.kcpGroupId = null;
            this.regionId = null;
            this.regionName = null;
            this.sprKcpGroupId = null;
            this.sprKcpGroupName = null;

            this.columnNum = columnNum;
            this.kcpGroupId = row.kcpGroup.id;
            this.regionId = row.regionId;
            this.regionName = row.regionName;
            this.uslName = row.kcpGroup?.usl?.name;
            this.foName = row.fo?.name;
            this.sprKcpGroupId = row.kcpGroup.id;
            this.sprKcpGroupName = row.kcpGroup.code + ' ' + row.kcpGroup.name;
            this.row = row;
            this.pb = row.dj === null && row.pp === null && row.pv === null;

            if (dash != null) {
                this.dialog = true;
            }
        }
    },
}